import styles from 'components/Header/NavDropdown/nav-dropdown.module.scss';
import NavDropdownItem from 'components/Header/NavDropdownItem';

import type { MenuItem } from 'components/Header/headerTypes';
import type { FC, RefObject } from 'react';

interface NavDropdownProps {
  expanded: boolean;
  items: MenuItem[];
  ref: RefObject<HTMLUListElement | null>;
  handleClick: () => void;
}

const NavDropdown: FC<NavDropdownProps> = ({ ref, expanded, items, handleClick }) => (
  <div>
    {expanded && (
      <div className={styles.dropdown}>
        <div className={styles.dropdownMenu}>
          <ul ref={ref}>
            {items &&
              items.map(({ subMenuItems = [] }, parentIndex) =>
                subMenuItems.map(({ label = '', url = '', isBold = false }, index) => {
                  const isDivider =
                    items.length - 1 !== parentIndex && subMenuItems.length - 1 === index && items.length > 1;

                  return (
                    <NavDropdownItem
                      key={label}
                      title={label}
                      link={url}
                      handleClick={handleClick}
                      data-testid={`dropdownItem--${label.toLowerCase()}`}
                      modifiers={[isBold ? 'bold' : '', isDivider ? 'divider' : '']}
                    />
                  );
                }),
              )}
          </ul>
        </div>
      </div>
    )}
  </div>
);

export default NavDropdown;
